import { Line } from "react-chartjs-2";
import "chart.js/auto";
import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../withRouter";
import TotalTransacTimePresenter from "./TotalTransacTimePresenter";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../../usecases/object";
import Export from "../../../../components/Export";
import printChart from "../../../../PrintChart";
import { format, startOfDay, addHours, addMinutes, addDays } from "date-fns";
import DefaultState from "../../../sales-and-transactions/components/DefaultState";
import Select from "react-select";
import InitialPrompt from "../../../../components/InitialPrompt";
import TransactionCountByTimeReport from "./components/TransactionCountByTimeReport";
import { exportTransactionTypesByHourCSV } from "./utils/transactionTypesByHourCsvUtils";
import ProgressLoader from "../../../../components/ProgressLoader";

class TotalTransacTimePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TotalTransacTimePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      selectedDate: new Date().toISOString().split("T")[0],
      selectedStoreCode: "",
      store: [],
      storess: "",
      notFound: false,
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", "")
    );

    return [...new Set(storeCodes)]; // Remove duplicates
  }

  handleDateChange(event) {
    const selectedDate = event.target.value;
    const formattedDate = this.formatDate(selectedDate);
    this.setState({ selectedDate: event.target.value });
    this.presenter.onChangeDate(formattedDate);
  }

  formatDate(dateString) {
    const date = new Date(dateString);

    const startTime = new Date(date);
    startTime.setHours(5, 0, 0, 0);
    const formattedStartTime = this.formatDateToCustom(startTime);

    const endTime = new Date(date);
    endTime.setDate(endTime.getDate() + 1);
    endTime.setHours(4, 59, 0, 0);
    const formattedEndTime = this.formatDateToCustom(endTime);

    return {
      tran_date: {
        $gte: formattedStartTime,
        $lte: formattedEndTime,
      },
    };
  }

  formatDateToCustom(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  filterTransactions(transactions) {
    const selectedDate = new Date(this.state.selectedDate);
    selectedDate.setHours(0, 0, 0, 0);

    const startDate = addHours(startOfDay(selectedDate), 5);
    const endDate = addMinutes(addHours(addDays(startDate, 1), -1), 59);

    const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
    const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

    console.log("Selected Date Range: ", {
      $gte: formattedStartDate,
      $lte: formattedEndDate,
    });

    return transactions
      .filter((status) => status.status === "C")
      .filter((transaction) => {
        const transactionDate = new Date(transaction.tran_date);

        const transactionDateMatch =
          transactionDate >= startDate && transactionDate <= endDate;
        const storeCodeMatch = this.state.selectedStoreCode
          ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
            this.state.selectedStoreCode
          : true;

        return transactionDateMatch && storeCodeMatch;
      });
  }

  countTransactionTypesPerHour = (transactions) => {
    const counts = {
      DineIn: new Array(24).fill(0),
      GrabFood: new Array(24).fill(0),
      TakeOut: new Array(24).fill(0),
      Delivery: new Array(24).fill(0),
      Drive: new Array(24).fill(0),
      FoodPanda: new Array(24).fill(0),
    };

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    const filteredTransactions = transactions
      .filter((status) => status.status === "C")
      .filter((transaction) => {
        const transactionDate = new Date(transaction.tran_date);
        return transactionDate;
      });

    filteredTransactions.forEach((transaction) => {
      const hour = new Date(transaction.tran_date).getHours();
      const index = hour < 5 ? hour + 19 : hour - 5;
      switch (transaction.tran_type) {
        case "D": // Dine-in
          counts.DineIn[index]++;
          break;
        case "G": // GrabFood
          counts.GrabFood[index]++;
          break;
        case "T": // Take-out
          counts.TakeOut[index]++;
          break;
        case "U": // Take-out
          counts.Delivery[index]++;
          break;
        case "K": // Take-out
          counts.Drive[index]++;
          break;
        case "F": // Take-out
          counts.FoodPanda[index]++;
          break;
        default:
          break;
      }
    });

    return counts;
  };

  getChartData() {
    // this.presenter.getChartData();
    const filteredTransactions = this.filterTransactions(this.state.objects);
    const newCounts = this.countTransactionTypesPerHour(filteredTransactions);
    const labels = Array.from({ length: 24 }, (_, i) => {
      const hour = (5 + i) % 24;
      return `${hour}:00`;
    });
    return {
      labels: labels,
      datasets: [
        {
          label: "Dine-in",
          data: newCounts.DineIn,
          borderColor: "rgb(53, 162, 235)",
          backgroundColor: "rgba(53, 162, 235, 0.5)",
          fill: true,
        },
        {
          label: "GrabFood",
          data: newCounts.GrabFood,
          borderColor: "rgb(255, 205, 86)",
          backgroundColor: "rgba(255, 205, 86, 0.5)",
          fill: true,
        },
        {
          label: "Take-out",
          data: newCounts.TakeOut,
          borderColor: "rgb(75, 192, 192)",
          backgroundColor: "rgba(75, 192, 192, 0.5)",
          fill: true,
        },
        {
          label: "Delivery",
          data: newCounts.Delivery,
          borderColor: "rgb(400, 192, 192)",
          backgroundColor: "rgba(400, 192, 192, 0.5)",
          fill: true,
        },
        {
          label: "Drive-thru",
          data: newCounts.Drive,
          borderColor: "rgb(198, 219, 86)",
          backgroundColor: "rgba(198, 219, 86, 0.5)",
          fill: true,
        },
        {
          label: "FoodPanda",
          data: newCounts.FoodPanda,
          borderColor: "#db3373",
          backgroundColor: "#db3373",
          fill: true,
        },
      ],
    };
  }

  getChartOptions() {
    return {
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            text: "Total Transactions vs Time of Day (Hours)",
          },
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
          },
        },
      },
    };
  }

  exportToCSV = () => {
    const { objects, selectedDate, storess } = this.state;

    const transactionsOnDate = this.filterTransactions(objects);
    const transactionCounts = this.countTransactionTypesPerHour(objects);
    const chartData = this.getChartData();

    exportTransactionTypesByHourCSV(
      transactionsOnDate,
      storess,
      selectedDate,
      transactionCounts,
      chartData
    );
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const { objects, selectedDate, storess } = this.state;
    const chartData = this.getChartData();
    const chartOptions = this.getChartOptions();
    const chartId = "chart-container7";

    const storeOptions = [
      ...this.state.store.map((code) => ({
        value: code.name,
        label: code.name,
      })),
    ];

    const selectedOption = storeOptions.find(
      (opt) => opt.value === this.state.selectedStoreCode
    );
    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
          <h2 className="fw-bold text-capitalize">
            <span style={{ color: "black" }}>Total</span>
            <span style={{ color: "#83c14a" }}> Transaction</span>
            <span style={{ color: "black" }}> vs.</span>
            <span style={{ color: "#c5da55" }}> Time of Day</span>
          </h2>
          <Export
            exportCsv={this.exportToCSV}
            exportPdf={() => printChart(chartId)}
          />
        </div>

        <div className="row mb-2">
          <div className="col-sm-2">
            <input
              className="form-control"
              type="date"
              onChange={this.handleDateChange}
            />
          </div>
          <div className="col-sm-4">
            <Select
              options={storeOptions}
              value={selectedOption}
              onChange={(opt) => this.onChangeStore(opt.value)}
              placeholder="Select Store"
              isClearable={false}
              className="basic-single"
              classNamePrefix="select"
            />
          </div>
        </div>

        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 ? (
          <TransactionCountByTimeReport
            chartData={chartData}
            chartOptions={chartOptions}
            storess={storess}
            selectedDate={selectedDate}
            chartRef={this.chartRef7}
            containerId="chart-container7"
          />
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess && !this.state.notFound ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default withRouter(TotalTransacTimePage);
